// https://twosixbrochure-lstjmh75g-twosixstudio.vercel.app/swatch?sw%5B0%5D%5Btitle%5D=primary&sw%5B0%5D%5BbaseColor%5D=%2300529b&sw%5B0%5D%5Bamount%5D=20&sw%5B0%5D%5BlightAdjustment%5D=0.02&sw%5B0%5D%5BdarkAdjustment%5D=0.1&sw%5B0%5D%5BsaturationAdjustment%5D=0&sw%5B1%5D%5Btitle%5D=secondary&sw%5B1%5D%5BbaseColor%5D=%2300a9a1&sw%5B1%5D%5Bamount%5D=20&sw%5B1%5D%5BlightAdjustment%5D=0.02&sw%5B1%5D%5BdarkAdjustment%5D=0.07&sw%5B1%5D%5BsaturationAdjustment%5D=-0.34&sw%5B2%5D%5Btitle%5D=gray&sw%5B2%5D%5BbaseColor%5D=%23c3c8cd&sw%5B2%5D%5Bamount%5D=20&sw%5B2%5D%5BlightAdjustment%5D=0.02&sw%5B2%5D%5BdarkAdjustment%5D=0.15&sw%5B2%5D%5BsaturationAdjustment%5D=0&sw%5B3%5D%5Btitle%5D=vh&sw%5B3%5D%5BbaseColor%5D=%23b24745&sw%5B3%5D%5Bamount%5D=5&sw%5B3%5D%5BlightAdjustment%5D=0.07&sw%5B3%5D%5BdarkAdjustment%5D=0.1&sw%5B3%5D%5BsaturationAdjustment%5D=0&sw%5B4%5D%5Btitle%5D=h&sw%5B4%5D%5BbaseColor%5D=%23df8e43&sw%5B4%5D%5Bamount%5D=5&sw%5B4%5D%5BlightAdjustment%5D=0.07&sw%5B4%5D%5BdarkAdjustment%5D=0.1&sw%5B4%5D%5BsaturationAdjustment%5D=0&sw%5B5%5D%5Btitle%5D=mh&sw%5B5%5D%5BbaseColor%5D=%236b6499&sw%5B5%5D%5Bamount%5D=5&sw%5B5%5D%5BlightAdjustment%5D=0.07&sw%5B5%5D%5BdarkAdjustment%5D=0.1&sw%5B5%5D%5BsaturationAdjustment%5D=0&sw%5B6%5D%5Btitle%5D=ml&sw%5B6%5D%5BbaseColor%5D=%232ea1d4&sw%5B6%5D%5Bamount%5D=5&sw%5B6%5D%5BlightAdjustment%5D=0.07&sw%5B6%5D%5BdarkAdjustment%5D=0.1&sw%5B6%5D%5BsaturationAdjustment%5D=0&sw%5B7%5D%5Btitle%5D=l&sw%5B7%5D%5BbaseColor%5D=%234a8189&sw%5B7%5D%5Bamount%5D=5&sw%5B7%5D%5BlightAdjustment%5D=0.07&sw%5B7%5D%5BdarkAdjustment%5D=0.1&sw%5B7%5D%5BsaturationAdjustment%5D=0&sw%5B8%5D%5Btitle%5D=vl&sw%5B8%5D%5BbaseColor%5D=%2379af97&sw%5B8%5D%5Bamount%5D=5&sw%5B8%5D%5BlightAdjustment%5D=0.07&sw%5B8%5D%5BdarkAdjustment%5D=0.1&sw%5B8%5D%5BsaturationAdjustment%5D=0&sw%5B9%5D%5Btitle%5D=i&sw%5B9%5D%5BbaseColor%5D=%23707f83&sw%5B9%5D%5Bamount%5D=5&sw%5B9%5D%5BlightAdjustment%5D=0.07&sw%5B9%5D%5BdarkAdjustment%5D=0.1&sw%5B9%5D%5BsaturationAdjustment%5D=0&sw%5B10%5D%5Btitle%5D=graysecondary&sw%5B10%5D%5BbaseColor%5D=%23f2f5f8&sw%5B10%5D%5Bamount%5D=20&sw%5B10%5D%5BlightAdjustment%5D=0.02&sw%5B10%5D%5BdarkAdjustment%5D=0.1&sw%5B10%5D%5BsaturationAdjustment%5D=-0.09

export const colors = {
  primary: {
    100: "#f5faff",
    200: "#deefff",
    300: "#c7e5ff",
    400: "#b0daff",
    500: "#99cfff",
    600: "#82c4ff",
    700: "#6bb9ff",
    800: "#54afff",
    900: "#3da4ff",
    1000: "#2699ff",
    1100: "#0f8eff",
    1200: "#0083f7",
    1300: "#0077e0",
    1400: "#006bc9",
    1500: "#005eb3",
    1600: "#00529c",
    1700: "#004685",
    1800: "#003a6e",
    1900: "#002e57",
    2000: "#002240",
    base: "#00529b",
  },
  secondary: {
    100: "#f7fdfd",
    200: "#e3f9f8",
    300: "#cff5f3",
    400: "#bbf1ef",
    500: "#a8edea",
    600: "#94e9e5",
    700: "#80e5e0",
    800: "#6de1dc",
    900: "#59ddd7",
    1000: "#45d9d2",
    1100: "#32d5cd",
    1200: "#29c6bf",
    1300: "#25b3ac",
    1400: "#219f99",
    1500: "#1d8b86",
    1600: "#187873",
    1700: "#146460",
    1800: "#10504d",
    1900: "#0c3d3a",
    2000: "#082927",
    base: "#00a9a1",
  },
  gray: {
    100: "#f9fafa",
    200: "#eeeff1",
    300: "#e2e4e7",
    400: "#d6d9dd",
    500: "#cacfd3",
    600: "#bec4c9",
    700: "#b3b9bf",
    800: "#a7aeb5",
    900: "#9ba3ac",
    1000: "#8f98a2",
    1100: "#838e98",
    1200: "#77838e",
    1300: "#6d7883",
    1400: "#636d77",
    1500: "#59626b",
    1600: "#4f575f",
    1700: "#464d53",
    1800: "#3c4248",
    1900: "#32373c",
    2000: "#282c30",
    base: "#c3c8cd",
  },
  vh: {
    100: "#f5e6e5",
    200: "#dba4a3",
    300: "#c26361",
    400: "#8f3938",
    500: "#4d1f1e",
    base: "#b24745",
  },
  h: {
    100: "#faede0",
    200: "#ecbe92",
    300: "#df8e44",
    400: "#aa611d",
    500: "#5c3410",
    base: "#df8e43",
  },
  mh: {
    100: "#eae9f1",
    200: "#b5b2cd",
    300: "#807aa8",
    400: "#544f78",
    500: "#2d2a41",
    base: "#6b6499",
  },
  ml: {
    100: "#e1f2f9",
    200: "#95cfe9",
    300: "#49adda",
    400: "#227da5",
    500: "#124359",
    base: "#2ea1d4",
  },
  l: {
    100: "#e8f1f2",
    200: "#accdd2",
    300: "#71aab2",
    400: "#467a81",
    500: "#264146",
    base: "#4a8189",
  },
  vl: {
    100: "#e9f2ee",
    200: "#afcfc1",
    300: "#76ad94",
    400: "#4a7d66",
    500: "#284337",
    base: "#79af97",
  },
  i: {
    100: "#eceeef",
    200: "#bac2c4",
    300: "#89969a",
    400: "#5c686b",
    500: "#31383a",
    base: "#707f83",
  },
  graysecondary: {
    100: "#f9fafb",
    200: "#ebeef2",
    300: "#dde3e9",
    400: "#cfd7e0",
    500: "#c1ccd7",
    600: "#b3c1ce",
    700: "#a6b5c5",
    800: "#98aabc",
    900: "#8a9eb2",
    1000: "#7c93a9",
    1100: "#6e87a0",
    1200: "#627c96",
    1300: "#597088",
    1400: "#50657a",
    1500: "#47596c",
    1600: "#3d4e5e",
    1700: "#344250",
    1800: "#2b3742",
    1900: "#222b34",
    2000: "#192027",
    base: "#f2f5f8",
  },
};
